    var klaviyo = klaviyo || [];
    klaviyo.init({
      account: "Q4R8hU",
      platform: "shopify",
            exclude_on_tags:"limited-edition"
    });
    klaviyo.enable("backinstock",{ 
    trigger: {
      product_page_text: "JOIN THE WAITLIST",
      product_page_class: "btn",
      product_page_text_align: "center",
      product_page_margin: "10px 0",
      replace_anchor: false
    },
    modal: {
     headline: "{product_name}",
     body_content: "Register to receive a notification when this item comes back in stock.",
     email_field_label: "Email",
     button_label: "JOIN THE WAITLIST",
     subscription_success_label: "You're in! We'll let you know when it's back.",
     footer_content: '',
     background_color: "#fff",
     close_button_color: "#ccc",
     error_background_color: "#fcd6d7",
     error_text_color: "#C72E2F",
     success_background_color: "#d3efcd",
     success_text_color: "#1B9500"
    }
  });